<div class="modal" id="driversSalaryDaysModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-header">
				<a routerLink="/drivers/{{ driver?.driver }}" target="_blank">
					{{ driver?.name }}
				</a>
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="modal-body">
				<table class="table table-striped table-hover">
					<thead class="table-dark">
						<tr>
							<th class="align-middle">Dzień</th>
							<th class="align-middle">Od</th>
							<th class="align-middle">Do</th>
							<th class="align-middle">Stawka</th>
							<th></th>
							<th></th>
							<th></th>
							<th class="align-middle">Dieta</th>
							<th class="align-middle">Wynagrodzenie</th>
							<th class="align-middle">Dodatek\Potrącenie</th>
							<th class="align-middle">Komentarz</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of driversSalaryDays; let id = index">
							<td>{{ item.day }}</td>
							<td>{{ item.timeFrom }}</td>
							<td>{{ item.timeTo }}</td>
							<td class="text-end align-midle" colspan="4">
								<select
									type="text"
									class="form-select"
									name="type_{{ id }}"
									[ngModel]="item.type"
									(ngModelChange)="changeSalaryType($event, item)"
									[disabled]="!editable || item.confirmMonth === '2'"
								>
									<option [value]="item.id" *ngFor="let item of salaryType">
										{{ item.name }}
									</option>
								</select>
							</td>
							<td class="text-end align-midle">
								<select
									type="text"
									class="form-select"
									name="diet_{{ id }}"
									[(ngModel)]="item.diet"
									[disabled]="!editable || item.confirmMonth === '2'"
								>
									<option [value]="obj.value" [disabled]="obj.disabled" *ngFor="let obj of diets">
										{{ obj.name }}
									</option>
								</select>
							</td>
							<td class="text-end align-midle">
								<input
									type="number"
									step="0.01"
									class="form-control"
									name="salary_{{ id }}"
									[(ngModel)]="item.salary"
									[disabled]="!editable || item.confirmMonth === '2'"
								/>
							</td>
							<td class="text-end align-midle">
								<input
									type="number"
									step="0.01"
									class="form-control"
									name="value_{{ id }}"
									[(ngModel)]="item.value"
									[disabled]="!editable || item.confirmMonth === '2'"
								/>
							</td>
							<td class="text-end align-midle">
								<input
									type="text"
									class="form-control"
									name="comment_{{ id }}"
									[(ngModel)]="item.comment"
									[disabled]="!editable || item.confirmMonth === '2'"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="modal-footer">
				<div class="col">
					<button
						type="button"
						class="btn"
						[ngClass]="{
							'btn-danger': !driver?.confirmed,
							'btn-success': driver?.confirmed,
						}"
						*ngIf="!editable"
						(click)="confirmed(driver)"
					>
						Zatwierdź
					</button>
				</div>
				<div class="items-align-end">
					<button class="btn btn-primary" *ngIf="!driver?.confirmed && !editable" (click)="editable = true">
						Edytuj
					</button>
					<button class="btn btn-danger" *ngIf="editable" (click)="save()">Zapisz</button>
				</div>
				<div class="items-align-start col-12 row">
					<div class="text-start">
						<small class="mt-1" *ngIf="driver?.confirmed">
							Zatwierdzono przez:
							{{ historyOperationLast?.user }} -
							{{ historyOperationLast?.date | formatDateTime }}
						</small>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
